/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {WorkplaceGroup} from '../models/workplaceGroup';
import {EntityStore} from './entityStore';

export class WorkplaceGroupStore extends EntityStore {
  workplaceGroups = [];

  selectedWorkplaceGroup = undefined;

  constructor(rootStore) {
    super(rootStore, 'workplaceGroups', Api.workplaceGroups, WorkplaceGroup);
  }

  setSelectedWorkplaceGroupByName(workplaceGroupName) {
    this.selectedWorkplaceGroup = this.workplaceGroups.find(
      (workplaceGroup) => workplaceGroup.name === workplaceGroupName
    );
  }
}

decorate(WorkplaceGroupStore, {
  workplaceGroups: observable,
  selectedWorkplaceGroup: observable,
  setSelectedWorkplaceGroupByName: action,
});
